var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-table", {
    attrs: {
      isLoading: _vm.isLoading,
      mode: _vm.mode,
      columns: _vm.columns,
      rows: _vm.rows,
      totalRows: _vm.totalRows,
      selectOptions: _vm.selectOptions,
      paginationOptions: _vm.paginationOptions,
      sortOptions: _vm.sortOptions
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-per-page-change": _vm.onPerPageChange,
      "on-sort-change": _vm.onChangeSort,
      "on-selected-rows-change": _vm.selectionChanged
    },
    scopedSlots: _vm._u([
      {
        key: "table-row",
        fn: function(props) {
          return [
            props.column.field == "name"
              ? [
                  _c("div", { staticClass: "mb-2" }, [
                    _c("span", { staticClass: "mr-2" }, [
                      _c("a", { attrs: { href: props.row.url } }, [
                        _vm._v(_vm._s(props.row.name))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  props.row.datetime_create
                    ? _c("div", [
                        _c("span", { staticClass: "mr-2" }, [
                          _vm._v(_vm._s(props.row.datetime_create))
                        ])
                      ])
                    : _vm._e()
                ]
              : props.column.field == "catalog_quantity"
              ? [
                  _c("vue-quantity", {
                    attrs: {
                      quantity: Number(props.row.catalog_quantity),
                      measure: props.row.measureTitle
                    }
                  })
                ]
              : props.column.field.substr(0, 20) == "catalog_price_scale_"
              ? [
                  _c("span", { staticClass: "text-nowrap" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(props.row[props.column.field]) +
                        "\n\t\t\t"
                    )
                  ])
                ]
              : props.column.field == "quantity"
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "product-amount form-inline d-inline-block mw-100",
                      attrs: { "data-entity": "quantity-block" }
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: props.row.quantity,
                              expression: "props.row.quantity",
                              modifiers: { number: true }
                            }
                          ],
                          staticClass:
                            "product-amount-field form-control form-control-sm",
                          attrs: {
                            type: "text",
                            name:
                              _vm.$attrs.params.arParams
                                .PRODUCT_QUANTITY_VARIABLE
                          },
                          domProps: { value: props.row.quantity },
                          on: {
                            change: function($event) {
                              return _vm.quantityChange(props.row)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                props.row,
                                "quantity",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ])
                    ]
                  )
                ]
              : props.column.field == "actions"
              ? [
                  props.row.can_buy
                    ? [
                        _c(
                          "button",
                          {
                            ref: "buttonAdd2basket",
                            staticClass: "btn btn-primary",
                            on: {
                              click: function($event) {
                                return _vm.click(props.row)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "flaticon2-shopping-cart-1 pr-0"
                            })
                          ]
                        )
                      ]
                    : [
                        _c("div", {
                          staticClass: "product-item-button-container"
                        })
                      ]
                ]
              : [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(props.formattedRow[props.column.field]) +
                      "\n\t\t"
                  )
                ]
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }